import {productHelper, ProductsEnum, resourcesHelper} from "@falcon/services";
import * as React from "react";
import * as moment from "moment";
import {Link} from "react-router-dom";
import {getAmountToDisplay} from "../../CommonFunctions";
import {
    DocVersionEnum as MotorDocVersionEnum,
    getDocumentBrand,
    getDocumentVersionByDate as getMotorDOIDocumentVersion,
    getHomeDOIDocumentVersion,
    HomeDocVersionEnum
} from "@falcon/plugin-falcon-journey";

interface IProps {
    unpaidChangeDueDate: string;
    interaction: any;
}

export class UnpaidChangeBanner extends React.Component<IProps> {
    private basePath = "/resources/documents/";
    private readonly motorDOIVersion: MotorDocVersionEnum;
    private readonly homeDOIVersion: HomeDocVersionEnum;
    private readonly brand: string;
    private readonly isHome: boolean;

    constructor(props: IProps) {
        super(props);
        const policyStartDateAsString: string = this.props.interaction.renewalDetails?.periodStartDate ?? this.props.interaction.factors.originalQuoteDate;
        const policyStartDate: Date = new Date(policyStartDateAsString);

        this.motorDOIVersion = getMotorDOIDocumentVersion(policyStartDate);
        this.homeDOIVersion = getHomeDOIDocumentVersion(policyStartDate);
        this.brand = getDocumentBrand(this.motorDOIVersion);
        this.isHome = productHelper.isHome(this.props.interaction);
    }

    getDOIPath(){
        return `${this.basePath}/LV_${this.brand}_Annual_Car/${this.motorDOIVersion}/LV_${this.brand}_Annual_Car_DOI_${this.motorDOIVersion}.pdf`
    }

    public render() {

        const { interaction, unpaidChangeDueDate } = this.props;

        if (interaction.paymentDetails?.submittedForSettlement) {
            // Payment was already processed. Without that condition banner is still present after payment, until customer relogin.
            return null;
        }

        const additionalPremium = interaction.factors.additionalPremium;
        const dueDate = moment.utc(unpaidChangeDueDate, moment.ISO_8601);
        const todayDate = moment.utc(moment().toDate(), moment.ISO_8601);
        const daysLeft = dueDate.diff(todayDate, 'days') + 1;

        return (
            <div className="inner-container">
                <div className="banner unpaid-changes-banner">
                    <div className="overflow-auto banner-content">
                        <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon" />
                        <div className="banner-text inline-warning-text">
                            Due to your recent claim and as per&nbsp;
                            {this.getDocumentOfInsurancePdfLink()}
                            &nbsp;there is an outstanding balance of&nbsp;
                            <span className="font-weight-bold">{getAmountToDisplay(additionalPremium)}</span>
                            &nbsp;left to pay. You have {daysLeft} days to make this payment or your {this.isHome ? "home" : "car"} insurance may be cancelled.
                        </div>
                    </div>
                    <div className="banner-action">
                        {this.getPaymentPageLink()}
                    </div>
                </div>
            </div>
        );
    }

    private getDocumentOfInsurancePdfLink(): React.ReactNode {
        if (this.isHome) {
            const newDocumentWording: string = (this.homeDOIVersion !== HomeDocVersionEnum.V1 &&
                this.homeDOIVersion !== HomeDocVersionEnum.V2) ? " Online" : "";

            return <React.Fragment>
            <a href={`/resources/documents/LV_Allianz_Annual_Home/${this.homeDOIVersion}/LV_Allianz_Home_DOI.pdf`}
               download={`Allianz${newDocumentWording} Home Document of Insurance`}
               className="text-decoration-underline muli-bold-16-blue">T&Cs
            </a>
            </React.Fragment>
        } else {
            return <React.Fragment>
                <a href={`${this.getDOIPath()}`} download="Allianz Car Document of Insurance (DOI)"
                   className="text-decoration-underline muli-bold-16-blue">T&Cs
                </a>
            </React.Fragment>
        }
    }

    private getPaymentPageLink(): React.ReactNode {
        const additionalPremium = this.props.interaction.factors.additionalPremium;
        const motorPaymentChoice = "/journey/init/product/AnnualMotorInsurance/process/mtaClaimImpact/presetPage/" + this.props.interaction._id;
        const homePaymentChoice = "/journey/init/product/AnnualHomeInsurance/process/mtaClaimImpact/presetPage/" + this.props.interaction._id;
        if (this.isHome) {
            return (
                <Link id="payNow" className="btn btn-primary btn-next-no-arrow mt-3 mb-0"
                      state={{
                          verifyCardFailed: false,
                          product: ProductsEnum.HOME
                      }}
                      to={homePaymentChoice}>
                    Pay {getAmountToDisplay(additionalPremium)} now
                </Link>
            )
        } else {
            return (
                <Link id="payNow" className="btn btn-primary btn-next-no-arrow mt-3 mb-0"
                      state={{
                          verifyCardFailed: false,
                          product: ProductsEnum.WOLF_MOTOR
                      }}
                      to={motorPaymentChoice}>
                    Pay {getAmountToDisplay(additionalPremium)} now
                </Link>
            )
        }
    }
}
